import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarEvent = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Arrangement",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 35.963 40.438",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_2850",
		"data-name": "Group 2850",
		transform: "translate(-960 -288.693)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "calendar_today_FILL0_wght300_GRAD0_opsz48",
			d: "M143.052,231.824A3.085,3.085,0,0,1,140,228.773V198.139a3.085,3.085,0,0,1,3.051-3.051h3.905v-3.7h2.665v3.7h16.8v-3.7h2.6v3.7h3.885a3.085,3.085,0,0,1,3.051,3.051v30.633a3.085,3.085,0,0,1-3.051,3.051Zm0-2.4h29.861a.7.7,0,0,0,.651-.651V207.761H142.4v21.012a.7.7,0,0,0,.651.651ZM142.4,205.36h31.162v-7.221a.7.7,0,0,0-.651-.651H143.052a.7.7,0,0,0-.651.651Zm0,0v0Z",
			transform: "translate(819.999 97.307)"
		}), /* @__PURE__ */ _jsx("path", {
			id: "star_FILL1_wght300_GRAD0_opsz48",
			d: "M131.927,282.463l1.314-5.66L128.85,273l5.794-.5,2.26-5.337,2.26,5.337,5.794.5-4.391,3.806,1.314,5.66-4.977-3Z",
			transform: "translate(841.077 40.513)"
		})]
	})
});
export default SvgCalendarEvent;
